import routerOptions0 from "/root/front/node_modules/.pnpm/nuxt@4.0.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler-_0531694196dc456235df74f6ff64da10/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}